import {
  EClickableTarget,
  EClickableTypes,
  EClickableVariants,
} from '@/components/atoms/at-clickable/at-clickable.types';
import { EIcons } from '@/components/atoms/at-icon/icons';
import {
  ILinksColumn,
  IActionLinks,
  ILink,
  IOrFooterProps,
} from './or-footer.types';

export const footerMainLinks: ILinksColumn[] = [
  {
    header: 'Custom Homes',
    links: [
      { label: 'Our Floorplans', href: '#' },
      { label: 'Our Process', href: '#' },
      { label: 'Included Features', href: '#' },
      { label: 'Gallery', href: '#' },
    ],
  },
  {
    links: [
      { label: 'Accessible Design', href: '#' },
      {
        label: 'What Is Simply Custom?',
        href: '#',
      },
      {
        label: 'Multi-Generational Living',
        href: '#',
      },
    ],
  },
  {
    header: 'Where we build',
    links: [
      { label: 'Explore the Map', href: '#' },
      { label: 'Visit a Model Home', href: '#' },
      { label: 'Design Centers', href: '#' },
      { label: 'Lot Vision', href: '#' },
    ],
  },
  {
    header: 'Company',
    links: [
      { label: 'About Us', href: '#' },
      { label: 'Financing', href: '#' },
      { label: 'FAQs', href: '#' },
      { label: 'News & Press', href: '#' },
      { label: 'Join Our Team', href: '#' },
    ],
  },
];

export const footerActionLinks: IActionLinks = {
  copyright: 'Copyright 2025 by Schumacher Homes, Ltd',
  socialLinks: [
    {
      key: 'blt1935596aab30f994',
      href: 'www.facebook.com',
      target: EClickableTarget.BLANK,
      icon: EIcons.FACEBOOK,
    },
    {
      key: 'bltb9dda1fc322ebbb5',
      href: 'www.youtube.com',
      target: EClickableTarget.BLANK,
      icon: EIcons.YOUTUBE,
    },
    {
      key: 'blt3f9c94cda4b1508a',
      href: 'www.pinterest.com',
      target: EClickableTarget.BLANK,
      icon: EIcons.PINTEREST,
    },
    {
      key: 'bltc9483cf1d6457183',
      href: 'www.linkedin.com',
      target: EClickableTarget.SELF,
      icon: EIcons.LINKEDIN,
    },
    {
      key: 'blt6543efa91cb80f4b',
      href: 'www.instagram.com',
      target: EClickableTarget.BLANK,
      icon: EIcons.INSTAGRAM,
    },
  ],
  actionButtons: {
    authCTA: {
      label: 'LOGIN OR SIGN UP',
      href: '/',
      outline: false,
      type: EClickableTypes.LINK,
    },
    cta1: {
      label: 'Schedule a Visit',
      href: '/',
      outline: true,
      variant: EClickableVariants.PRIMARY,
      type: EClickableTypes.CTA,
    },
    cta2: {
      label: 'Search for Plans',
      href: '/',
      outline: false,
      underline: false,
      variant: EClickableVariants.TERTIARY,
      type: EClickableTypes.CTA,
    },
    phoneNumber: '855-855-8555',
  },
};

export const footerLegalLinks: ILink[] = [
  { label: 'Privacy Policy', href: '#' },
  { label: 'Terms of Use', href: '#' },
  { label: 'Consent Preferences', href: '#' },
  { label: 'Events', href: '#' },
  { label: 'Contact', href: '#' },
  { label: 'Site Search', href: '#' },
];

export const orFooterMockData: IOrFooterProps = {
  legalLinks: footerLegalLinks,
  mainLinks: footerMainLinks,
  actionLinks: footerActionLinks,
};
